import { getLines, Transformer } from "@buurman/commons";
import { pathExists, readFile, unlink, writeFile } from "fs-extra";
import FileMutator from "./FileMutator";

export interface FileApi {
    exists(): Promise<boolean>;
    get(): Promise<string>;
    getLines(): Promise<string[]>;

    set(content: string): this;
    append(content: string): this;
    prepend(content: string): this;
    setLines(lines: string[]): this;
    appendLines(lines: string[]): this;
    prependLines(lines: string[]): this;
    transform(transformer: Transformer<string>): this;
    mapLines(transformer: Transformer<string>): this;

    delete(): Promise<void>;
    save(): Promise<void>;
}

const file = (path: string): FileApi => {
    const { mutations, applyMutations } = FileMutator(() => api);

    const api: FileApi = {
        exists: () => pathExists(path),
        get: async () => ((await api.exists()) ? readFile(path, "utf-8") : ""),
        getLines: async () => getLines(await api.get()),

        ...mutations,

        delete: async () => {
            if (!(await api.exists())) {
                return;
            }

            await unlink(path);
        },
        save: async () => {
            await writeFile(path, applyMutations(await api.get()));
        },
    };

    return api;
};

export default file;
